import { lsPut, safeAwait } from 'utils/request'

export const recordArticleReserveClicked = (articleId) => {
  return safeAwait(lsPut(`/articles/${articleId}/gotoReservationViews`))
}
